import StorageServiceRepository from "../../ports/storageServiceRepository";

export type downloadFileUsecase = (
  fileUrl: string,
  customFileName?: string
) => Promise<void>;

export const buildDownloadFile = (dependencies: {
  storageServiceRepo: StorageServiceRepository;
}): downloadFileUsecase => {
  const { storageServiceRepo } = dependencies;

  const downloadFile: downloadFileUsecase = async (
    fileUrl: string,
    customFileName?: string,
  ) => storageServiceRepo.downloadFile(fileUrl, customFileName);

  return downloadFile;
};
